import triggerDownload from "js-file-download";

export function downloadCsv(csv: string, fileName: string) {
  triggerDownload(csv, fileName, "text/csv");
}
